import { ReactNode, useCallback, useEffect, useRef, useState } from 'react';
import { Box, Dialog, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { decode } from '@googlemaps/polyline-codec';
import CustomDataGrid from '../../../../common/components/customized/customdatagrid/CustomDataGrid';
import CustomButton from '../../../../common/components/buttons/CustomButton';
import AddTrip from './components/AddTrip';
import CustomDialog from '../../../../common/components/customdialog/CustomDialog';
import {
  deactivateAction,
  deleteTrips,
  driverAction,
  tripsDeviceAction,
  tripTypesAction
} from '../../redux/reducer/yaantracSlices/mytripsSlice';
import { useAppDispatch, useAppSelector } from '../../../../app/redux/hooks';
import { Icon } from '@iconify/react';
import constant from '../../../../utils/constants';
import constants from '../../../../utils/constants';
import {
  updateFence,
  updateIsShow
} from '../../../../common/redux/reducer/commonSlices/circleSlice';
import {
  map,
  updateCenter,
  updateZoom
} from '../../../../common/redux/reducer/commonSlices/mapSlice';
import {
  createConnection,
  updateData
} from '../../../../common/redux/reducer/commonSlices/websocketSlice';
import ShareTrip from './components/ShareTrip';
import { updatePolyline } from '../../../../common/redux/reducer/commonSlices/polylineSlice';
import CustomTab from '../../../../common/components/tab/CustomTab';
import { PaginationModel } from '../reports/Reports';
import './MyTrips.scss';
import { capitalizeFirstLetter, usePagination } from '../../../../utils/commonFunctions';
import CustomIconButton from '../../../../common/components/buttons/CustomIconButton';
import { fileURLToPath } from 'url';
import LoginRedirect from '../../../../common/components/loginredirect/LoginRedirect';
import CustomPortal from '../../../../common/components/portals/CustomPortal';
import { GridActionsCellItem } from '@mui/x-data-grid';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import EditIcon from '@mui/icons-material/Edit';
import BlockIcon from '@mui/icons-material/Block';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MoreVertIcon from '@mui/icons-material/MoreVert';

interface Column {
  title: string;
  field: string;
  headerName: string;
  flex: number;
  minWidth: number;
  maxWidth?: number;
  sortable?: boolean;
  type?: any;
  renderCell?: (params: { value: any }) => React.ReactNode | null;
  getActions?: (params: any) => React.ReactNode | null;
}

interface TripData {
  id: number;
  tripID: number;
  userID: string;
  vehicleNumber: string;
  startTime: number;
  endTime: number;
  startLatitude: number;
  startLongitude: number;
  endLatitude: number;
  endLongitude: number;
  tripStatus: string;
  isActive: number;
  notificationStatus: number;
  startGeoZoneColor: string | null;
  startGeoZoneRadius: number | null;
  endGeoZoneColor: string | null;
  endGeoZoneRadius: number | null;
  tripPathLatAndLngDetails: any;
}
interface MyTripsProps {
  boolValue?: boolean; // Optional boolean value
  driverID?: string;
  setChildState?: React.Dispatch<React.SetStateAction<any>> | any;
  children?: any;
}

function MyTrips({ boolValue = true, driverID, setChildState, children }: MyTripsProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [view, setView] = useState<boolean>(false);
  const [openShare, setOpenShare] = useState<boolean>(false);
  const [filteredRow, setfilteredRow] = useState<TripData[] | any>([]);
  const [isViewData, setIsViewData] = useState<TripData[] | any>([]);
  const [isUpdateData, setIsUpdateData] = useState<TripData[] | any>([]);
  const [isDialog, setIsDialog] = useState('');
  const { pageSize, pageNo, pagination, setPageNo, setPageSize } = usePagination();
  const [driverDetails, setDriverDetails] = useState(false);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [tripType, setTripType] = useState<any>('Expired');
  const [tabValue, setTabValue] = useState(0);
  const [Animation, setAnimation] = useState('animate__animated animate__slideInRight');
  const openMenu = Boolean(anchorEl);

  const abortController = useRef<AbortController | null>(null);

  const dispatch = useAppDispatch();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const deviceListData = useAppSelector(state => state.tripsDeviceList?.data);
  const driverIds = useAppSelector(state => state.driverIds);
  const { connection, data } = useAppSelector(state => state.websocket);
  const allVehicleData = useAppSelector(state => state.dashboardVehiclesStatus);
  const { rows, isLoading, count } = useAppSelector(state => state.tripTypes);
  const { isLoading: deleteLoading } = useAppSelector(state => state.deleteTrips);
  let tripList = ['Expired', 'Scheduled', 'Completed', 'In Complete'];
  const { isLoading: deactivateLoading } = useAppSelector(
    state => state.deactivateTripSlice
  );
  const handleView = (items: any) => {
    // if (items?.length !== 0) dispatch(createConnection(items?.vehicleNumber));
    // dispatch(updateIsShow(true));
    // dispatch(
    //   updateFence([
    //     {
    //       id: 'start',
    //       center: { lat: items.startLatitude, lng: items.startLongitude },
    //       radius: items.startGeoZoneRadius
    //     },
    //     {
    //       id: 'end',
    //       center: { lat: items.endLatitude, lng: items.endLongitude },
    //       radius: items.endGeoZoneRadius
    //     }
    //   ])
    // );
  };
  //for pagination
  const handlePagination = async (newPaginationModel: PaginationModel) => {
    await dispatch(
      tripTypesAction({ ...pagination(newPaginationModel), tripType: tripType })
    );
  };

  const findRow = (row: any) => {
    const [filteredData] = rows
      ?.filter((item: any) => item.tripID === row?.tripID)
      .map((item: any) => ({
        ...item,
        tripType: tripType
      }));
    return filteredData;
  };

  useEffect(() => {
    if (connection) {
      connection.onopen = () => {};

      connection.onmessage = (e: { data: string }) => {
        dispatch(updateData(JSON.parse(e?.data)));
      };

      connection.onclose = () => {};
    }

    return () => {
      if (connection) connection.close();
    };
  }, [connection]);

  // useEffect(() => {
  //   if (data && [data].length > 0) {
  //     const [filteredMarker]: any = allVehicleData?.data?.filter((value: any) => {
  //       return value.id === (data as { vehicle_number: any }).vehicle_number;
  //     });

  //     const convertedData = [data].map((item: any) => ({
  //       id: item.vehicle_number,
  //       lat: parseFloat(item.latitude),
  //       lng: parseFloat(item.longitude),
  //       type: filteredMarker?.type,
  //       name: filteredMarker?.type,
  //       status: item.vehicle_status,
  //       info: {
  //         speed: `${item.speed} kmph`,
  //         todayDistance: filteredMarker?.info?.todayDistance,
  //         totalDistance: `${item.total_distance} KM`,
  //         driverName: filteredMarker?.info?.driverName,
  //         driverContactNo: filteredMarker?.info?.driverContactNo
  //       }
  //     }));
  //     if (filteredRow?.vehicleNumber === (data as any)?.vehicle_number) {
  //       dispatch(map(convertedData));
  //     }
  //   }
  // }, [data, filteredRow]);

  const handleViewTrip = useCallback((row: any) => {
    const decoded = decode(row?.encodedPolyline)?.map(([lat, lng]) => ({
      lat,
      lng
    }));
    const actualPolyline = row?.tripActualPolyline
      ? decode(row?.tripActualPolyline)?.map(([lat, lng]) => ({
          lat,
          lng
        }))
      : [];
    dispatch(
      updatePolyline([
        {
          id: 'planned',
          color: '#0f53ff',
          path: decoded
        },
        ...(['Completed', 'In Complete'].includes(tripType)
          ? [
              {
                id: 'actual',
                color: 'red',
                path: actualPolyline
              }
            ]
          : [])
      ])
    );
    dispatch(updateCenter([...decoded, ...actualPolyline]));
    dispatch(updateZoom([...decoded, ...actualPolyline]));
    setView(true);

    handleClose();
    setIsViewData(row);
    const rowData = row;
    const waypointsZone =
      rowData?.waypointDetails?.map((value: any, index: number) => ({
        id: `${index + 1}`,
        center: { lat: value.waypointLat, lng: value.waypointLng },
        radius: value.waypointRadius
      })) || [];

    dispatch(
      updateFence([
        {
          id: 'start',
          center: { lat: rowData.startLatitude, lng: rowData.startLongitude },
          radius: rowData.startGeoZoneRadius
        },
        ...waypointsZone,
        {
          id: 'end',
          center: { lat: rowData.endLatitude, lng: rowData.endLongitude },
          radius: rowData.endGeoZoneRadius
        }
      ])
    );
  }, []);

  const handleDeleteTrip = async () => {
    let payload = { tripType: tripType, tripID: filteredRow.tripID };
    await dispatch(deleteTrips(payload));
    setPageNo(1);
    setPageSize(5);
    await dispatch(tripTypesAction({ tripType: tripType, pageNo: 1, pageSize: 5 }));

    setIsDialog('');
  };

  const handleUpdateTrip = useCallback((row: any) => {
    const decoded = decode(row?.encodedPolyline)?.map(([lat, lng]) => ({
      lat,
      lng
    }));
    dispatch(
      updatePolyline([
        {
          id: 'actual',
          color: '#0f53ff',
          path: decoded
        }
      ])
    );
    dispatch(updateCenter(decoded));
    dispatch(updateZoom(decoded));
    setIsOpen(true);
    setIsUpdateData(row);
    handleClose();
  }, []);

  const handleViewClose = () => {
    setView(false);
    dispatch(updateIsShow(false));
    dispatch(updatePolyline([]));
    setIsUpdateData([]);
  };

  const handleClose = () => setAnchorEl(null);

  const handleTrip = async (e: any, newValue: any) => {
    if (abortController.current) {
      await abortController.current.abort();
    }
    abortController.current = new AbortController();
    const { signal } = abortController.current;
    setPageNo(1);
    setTabValue(newValue);
    switch (newValue) {
      case 0:
        setTripType('Expired');
        await dispatch(
          tripTypesAction({
            tripType: 'Expired',
            pageNo: 1,
            pageSize: 5,
            driverID: driverIds?.driverId,
            signal: signal
          })
        );
        break;
      case 1:
        setTripType('Scheduled');
        await dispatch(
          tripTypesAction({
            tripType: 'Scheduled',
            pageNo: 1,
            pageSize: 5,
            driverID: driverIds?.driverId,
            signal: signal
          })
        );
        break;
      case 2:
        setTripType('Completed');
        await dispatch(
          tripTypesAction({
            tripType: 'Completed',
            pageNo: 1,
            pageSize: 5,
            driverID: driverIds?.driverId,
            signal: signal
          })
        );
        break;
      case 3:
        setTripType('In Complete');
        await dispatch(
          tripTypesAction({
            tripType: 'In Complete',
            pageNo: 1,
            pageSize: 5,
            driverID: driverIds?.driverId,
            signal: signal
          })
        );
        break;
      default:
        break;
    }
  };
  const columns: Column[] = [
    {
      field: 'actions',
      headerName: constant.Action,
      title: 'actions',
      type: 'actions',
      flex: 1,
      minWidth: 100,
      sortable: false,
      getActions: (params: any) => {
        const row = params.row;
        const isActive = row?.isActive === 1;
        const isInTransit = row?.tripStatus === 'IN_TRANSIT';
        const isCompleted = tripType === 'Completed';

        return [
          <GridActionsCellItem
            icon={<Icon icon='bx:trip' className='menu-icon view' />}
            label={constant.View}
            onClick={() => {
              handleView(row);
              setfilteredRow(() => findRow(row));
              handleViewTrip(row);
            }}
            disabled={!isActive}
            showInMenu
          />,
          !isCompleted && !['Completed', 'In Complete']?.includes(tripType) && (
            <GridActionsCellItem
              icon={<EditIcon sx={{ fontSize: 18, color: '#fb8c00' }} />}
              label={constant.Update}
              onClick={() => {
                handleView(row);
                setfilteredRow(() => findRow(row));
                handleUpdateTrip(row);
              }}
              disabled={!isActive || isInTransit}
              showInMenu
            />
          ),
          !['Completed', 'In Complete']?.includes(tripType) && (
            <GridActionsCellItem
              icon={
                isActive ? (
                  <BlockIcon sx={{ fontSize: 18, color: '#616161' }} />
                ) : (
                  <CheckCircleIcon sx={{ fontSize: 18, color: '#2e7d32' }} />
                )
              }
              label={isActive ? constants.Deactive : constants.ActiveStatus}
              onClick={() => {
                handleView(row);
                setfilteredRow(() => findRow(row));
                setIsDialog('dialog');
                handleClose();
              }}
              disabled={isInTransit}
              showInMenu
            />
          ),
          !['Completed', 'In Complete']?.includes(tripType) && (
            <GridActionsCellItem
              icon={<DeleteOutlineIcon sx={{ fontSize: 18, color: '#f44336' }} />}
              label={constants.Delete}
              onClick={() => {
                handleView(row);
                setfilteredRow(() => findRow(row));
                setIsDialog('Delete');
                handleClose();
              }}
              disabled={!isActive || isInTransit}
              showInMenu
            />
          )
        ].filter(Boolean);
      }
    },
    {
      title: 'Status',
      field: 'isActive',
      headerName: 'Status',
      flex: 1,
      sortable: false,
      minWidth: 100,
      maxWidth: 100,
      renderCell: ({ value }) =>
        value === 1 ? (
          <Icon icon='carbon:circle-filled' style={{ color: '#0EBC93' }} />
        ) : (
          <Icon icon='carbon:circle-filled' style={{ color: '#FF2532' }} />
        )
    },
    {
      title: 'Trip ID',
      field: 'tripID',
      headerName: 'Trip ID',
      flex: 1,
      minWidth: 100
    },
    {
      title: 'Vehicle Number',
      field: 'vehicleNumber',
      headerName: 'Vehicle No',
      flex: 1,
      minWidth: 150,
      renderCell: ({ value }) => value?.toUpperCase()
    },
    {
      title: 'Assigned Driver',
      field: 'driverName',
      headerName: 'Assigned Driver',
      flex: 1,
      minWidth: 150,
      renderCell: ({ row }: any) => (
        <Icon
          icon='el:eye-open'
          style={{
            color: 'rgb(8 26 12)',
            width: '26px',
            height: '26px',
            cursor: 'pointer'
          }}
          onClick={() => {
            setDriverDetails(true);
            setfilteredRow(() => findRow(row));
          }}
        />
      )
    },
    {
      title: 'Trip Driver',
      field: 'temporaryDriverName',
      headerName: 'Trip Driver',
      flex: 1,
      minWidth: 150
    },
    ...(tripType === 'Scheduled'
      ? [
          {
            title: 'Trip Status',
            field: 'status',
            headerName: 'Trip Status',
            flex: 1,
            minWidth: 150
          }
        ]
      : []),
    ...(tripType === 'Completed'
      ? [
          {
            title: 'Actual Start Date & Time',
            field: 'actualStartTimestamp',
            headerName: 'Actual Start Date & Time',
            flex: 1,
            minWidth: 250
          },
          {
            title: 'Actual End Date & Time',
            field: 'actualEndTimestamp',
            headerName: 'Actual End Date & Time',
            flex: 1,
            minWidth: 250
          }
        ]
      : []),
    {
      title: 'Start Date & Time',
      field: 'startTime',
      headerName: 'Start Date & Time',
      flex: 1,
      minWidth: 250
    },
    {
      title: 'End Date & Time',
      field: 'endTime',
      headerName: 'End Date & Time',
      flex: 1,
      minWidth: 200
    }
  ];

  const handleDeactivate = async () => {
    const payload: any = {
      endTimestamp: filteredRow?.endTimestamp,
      startTimestamp: filteredRow?.startTimestamp,
      tripID: filteredRow?.tripID,
      tripcode: filteredRow?.code,
      vehicleNumber: filteredRow?.vehicleNumber,
      tripType: filteredRow?.tripType
    };
    await dispatch(deactivateAction(payload));
    setIsDialog('');

    await dispatch(
      tripTypesAction({ tripType: filteredRow.tripType, pageNo: 1, pageSize: 5 })
    );
    setPageSize(5);
    setPageNo(1);
  };

  useEffect(() => {
    if (abortController.current) {
      abortController.current.abort();
    }
    abortController.current = new AbortController();
    const { signal } = abortController.current;
    dispatch(tripsDeviceAction());
    dispatch(driverAction());
    return () => {
      if (abortController.current) {
        abortController.current.abort();
      }
    };
  }, []);

  useEffect(() => {
    if (abortController.current) {
      abortController.current.abort();
    }
    abortController.current = new AbortController();
    const { signal } = abortController.current;
    if (!driverIds?.driverId) {
      dispatch(
        tripTypesAction({ tripType: 'Expired', pageNo: 1, pageSize: 5, signal: signal })
      );
    }
    return () => {
      if (abortController.current) {
        abortController.current.abort();
      }
    };
  }, [driverIds]);

  useEffect(() => {
    setAnimation('animate__animated animate__slideInRight');
    setPageNo(1);
    setPageSize(5);
  }, [tabValue, tripType]);

  useEffect(() => {
    if (!view) {
      setPageNo(1);
      setPageSize(5);
    }
  }, [view]);

  return (
    <>
      <Box className='trips-container'>
        <Box className='d-flex trips-add'>
          <CustomTab onChange={handleTrip} value={tabValue} tabList={tripList} />
          {boolValue && (
            <CustomButton
              className='saveChanges'
              category='Add New Trip'
              onClick={() => {
                setIsOpen(true);
                setIsUpdateData([]);
                dispatch(updatePolyline([]));
              }}
            />
          )}
        </Box>

        {isOpen && (
          <AddTrip
            setIsOpen={setIsOpen}
            isOpen={isOpen}
            data={deviceListData}
            setTab={setTabValue}
            setChildState={setChildState}
            children={children}
            setTripType={setTripType}
            row={isUpdateData}
            setPageNo={setPageNo}
            setPageSize={setPageSize}
            setUpdateData={setIsUpdateData}
          />
        )}

        <CustomDataGrid
          rows={rows ?? []}
          columns={columns}
          loading={isLoading}
          rowCount={count}
          type='autoplanner'
          pageNo={pageNo}
          tabsValue={tabValue}
          pageSize={pageSize}
          paginationModel={{
            page: pageNo && count ? pageNo - 1 : 0,
            pageSize: pageSize ?? 5
          }}
          onPaginationModelChange={handlePagination}
          onRowClick={(id, row) => {
            row.isActive === 1 && handleUpdateTrip(row);
          }}
        />

        <Dialog
          className='animate__animated animate__fadeInBottomRight animate__fast'
          BackdropProps={{
            invisible: true
          }}
          open={isDialog === 'Delete'}
        >
          <Box
            sx={{
              textAlign: 'center',
              padding: '5%',
              minWidth: '350px'
            }}
          >
            <Typography>{constants.DeleteTrip}</Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                paddingTop: '5%',
                justifyContent: 'center'
              }}
            >
              <Box sx={{ marginRight: '12px' }}>
                <CustomButton
                  className='saveChanges'
                  category='Yes'
                  loading={deleteLoading}
                  onClick={() => {
                    handleDeleteTrip();
                  }}
                />
              </Box>

              <CustomButton
                className='cancel'
                category='No'
                onClick={() => setIsDialog('')}
              />
            </Box>
          </Box>
        </Dialog>

        {isDialog === 'dialog' && (
          <Dialog open={isDialog === 'dialog'}>
            <Box
              sx={{
                textAlign: 'center',
                padding: '5%',
                width: '350px'
              }}
            >
              <Typography>
                {filteredRow.isActive === 1 ? constants.Deactivate : constants.Activate}
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  paddingTop: '5%',
                  justifyContent: 'center'
                }}
              >
                <Box sx={{ marginRight: '12px' }}>
                  <CustomButton
                    className='saveChanges'
                    loading={deactivateLoading}
                    category='Yes'
                    onClick={handleDeactivate}
                  />
                </Box>
                <CustomButton
                  className='cancel'
                  category='No'
                  onClick={() => {
                    setIsDialog('');
                  }}
                />
              </Box>
            </Box>
          </Dialog>
        )}

        {view && (
          <CustomDialog
            view={view}
            handleViewClose={handleViewClose}
            rowData={isViewData}
          />
        )}

        {openShare && (
          <ShareTrip
            openShare={openShare}
            setOpenShare={setOpenShare}
            row={filteredRow}
          />
        )}

        {driverDetails && (
          <Dialog
            className='animate__animated animate__fadeInBottomRight animate__fast'
            BackdropProps={{
              invisible: true
            }}
            open={driverDetails}
          >
            <Box
              sx={{
                textAlign: 'center',
                padding: '5%',
                minWidth: '350px'
              }}
            >
              <Typography>{'Driver Details'}</Typography>
              <Grid container mt={2}>
                {filteredRow?.mappedDrivers.length > 0
                  ? filteredRow?.mappedDrivers?.map((item: any) => (
                      <Grid item xs={6} display={'flex'} alignItems={"center"}>
                        <Icon
                          icon='healthicons:truck-driver-outline'
                          width='30px'
                          height='30px'
                        />
                        <Box>{capitalizeFirstLetter(item.driverName)}</Box>
                      </Grid>
                    ))
                  : 'No data found'}
              </Grid>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  paddingTop: '5%',
                  justifyContent: 'end'
                }}
              >
                <CustomButton
                  className='cancel'
                  category='cancel'
                  onClick={() => setDriverDetails(false)}
                />
              </Box>
            </Box>
          </Dialog>
        )}
      </Box>
      <LoginRedirect />
    </>
  );
}

export default CustomPortal(MyTrips);
